import wsUrl from './ws-url'
import message from './message'

export default function({ state, dispatch, commit, rootState }) {
    commit('startConnecting')

    // Verify the access token
    return dispatch('post', {
        url: '/provider/auth/verify/token',
        // Return the access token in the response
        data: {
			get: true
		}
    }, {
        root: true
    })
    .then((response) => {
        commit('finishConnecting')
        // Use the auth ID and access token to initiate a WS connection
        if (response.auth && response.access_token) {
            state.socket = new WebSocket(wsUrl + '?auth=' + response.auth + '&access_token=' + response.access_token)
            window.sock = state.socket

            state.socket.onopen = function() {
                if (state.queue.length > 0) {
                    state.queue.forEach((message) => {
                        state.socket.send(JSON.stringify(message))
                    })
                }
            }

            // Delegate each message received to it's respective module
			state.socket.onmessage = function(event) {
				var record = JSON.parse(event.data)
                // Ignore API Gateway errors
                if (record.message === 'Internal server error') return
                //console.log(record)

                if (message[record.source] && message[record.source][record.action])
                    message[record.source][record.action](record.data, (mutation, data) => {
                        commit(mutation, (data != null) ? data : record.data, { root: true })
                    }, rootState)
			}
        }
    })
    .catch((error) => {
        commit('finishConnecting')
        throw error
    })
}
